import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <main className="state-page">
      <section className="state-panel">
        <img src="/prentus-logo-black.png" alt="Prentus" className="prentus-wordmark" />
        <h1>This workspace is not available</h1>
        <p>Ask your Prentus contact for the current partnership link.</p>
        {import.meta.env.DEV && <Link className="button button-primary" to="/bay-path-preview">Open Bay Path preview</Link>}
      </section>
    </main>
  )
}
